import { messageValidator } from '../external/constants/message-validator.constants';

export class IdentityProviderHelper {
  static centerPopup(
    width: number,
    height: number
  ): { height: number; width: number; top: number; left: number } {
    const top: number = window.top.outerHeight / 2 + window.top.screenY - height / 2;
    const left: number = window.top.outerWidth / 2 + window.top.screenX - width / 2;

    return { height, width, top, left };
  }

  static validateMessageAndOrigin(event: MessageEvent, url: string) {
    let validMessage = false;
    if (
      event.origin === url &&
      Object.prototype.hasOwnProperty.call(event.data, messageValidator)
    ) {
      validMessage = true;
    }
    return validMessage;
  }

  static getMessageUrl(): string {
    let url = 'https://app.getaccept.com';
    if (window.location.href.includes('localhost') || window.location.href.includes('ga-staging')) {
      url = 'https://app.ga-staging.com';
    }
    return url;
  }

  static createIdentityProviderReqUrl(redirUrl: string, identityProvider: string): string {
    return `${IdentityProviderHelper.getMessageUrl()}/signup2/provider/${identityProvider}/?redirect=${encodeURIComponent(
      redirUrl
    )}`;
  }

  static createIdentityProviderRedirUrl(
    identityProvider: string,
    registrationSource: string,
    registrationCampaign: string,
    language: string,
    templateId?: string
  ): string {
    const baseUrl: URL = new URL(
      `${IdentityProviderHelper.getMessageUrl()}/signup2/provider/${identityProvider}/`
    );
    baseUrl.searchParams.append('user-registration-source', registrationSource);
    baseUrl.searchParams.append('user-registration-campaign', registrationCampaign);
    baseUrl.searchParams.append('user-language', language);

    if (templateId) {
      baseUrl.searchParams.append('template-id', templateId);
    }

    return baseUrl.toString();
  }
}
